export var MEDIA_QUERY = 1440;
export var MEDIA_QUERY_HEIGHT = 920;
export var MEDIA_QUERY_MOBILE = 940;
export var MEDIA_QUERY_NEW_MOBILE = 743;
export var MEDIA_QUERY_MOBILE_SMALL = 560;
export var WIDE_PRESENTATION_RATIO = 1.9;
export var FREE_TYPE_RATIO = 0;
export var LayoutConst = {
    container: {
        l_16: 1600,
        mac13: 1440,
        l_12: 1280,
        l: 1152,
        // m: 737
        //m: 862,
        md: 940,
        m: 888,
        s: 744,
        sm: 546,
        height: {
            projectCover: 920
        },
    },
    cover: {
        l: { w: 568, h: 798 },
        // m: { w: 366, h: 514, },
        m: { w: 432, h: 594 }
    },
    projectCard: {
        l: { w: 270, h: 380 },
        m: { w: 204, h: 288 },
        s: { w: 172.5, h: 243 }
    },
    projectCardGap: {
        l: 24,
        m: 24,
        s: 10
    },
    blockPadding: {
        m: { main: 35, space: 80, bottom: 36 }
    }
};
//# sourceMappingURL=media.js.mapexport var MEDIA_QUERY = 1440;
export var MEDIA_QUERY_HEIGHT = 920;
export var MEDIA_QUERY_MOBILE = 940;
export var MEDIA_QUERY_NEW_MOBILE = 743;
export var MEDIA_QUERY_MOBILE_SMALL = 560;
export var WIDE_PRESENTATION_RATIO = 1.9;
export var FREE_TYPE_RATIO = 0;
export var LayoutConst = {
    container: {
        l_16: 1600,
        mac13: 1440,
        l_12: 1280,
        l: 1152,
        // m: 737
        //m: 862,
        md: 940,
        m: 888,
        s: 744,
        sm: 546,
        height: {
            projectCover: 920
        },
    },
    cover: {
        l: { w: 568, h: 798 },
        // m: { w: 366, h: 514, },
        m: { w: 432, h: 594 }
    },
    projectCard: {
        l: { w: 270, h: 380 },
        m: { w: 204, h: 288 },
        s: { w: 172.5, h: 243 }
    },
    projectCardGap: {
        l: 24,
        m: 24,
        s: 10
    },
    blockPadding: {
        m: { main: 35, space: 80, bottom: 36 }
    }
};
//# sourceMappingURL=media.js.map